<div class="container-fluid d-print-none bg-brand">
    <div class="row">
        <div class="col px-md-8">
            <header class="d-flex align-items-center justify-content-between flex-nowrap flex-row">
                <ui-logo [additionalLogoImgClass]="'logo-img--xs'" />

                @if (user$ | async) {
                    <ui-icon-bs
                        class="ms-auto"
                        [type]="bsIconTypes.BoxArrowRight"
                        [pseudo]="'white'"
                        [queryParams]="{ redirectToLoginInModule: true }"
                        [routerLink]="[routeEntity.Root, routeEntity.Logout]" />
                }

                <ui-lang-checker
                    class="ms-3"
                    [selected]="selectedLang$ | async"
                    [languages]="languages$ | async"
                    (changeLang)="handlerChangeLang($event)" />
            </header>
        </div>
    </div>
</div>
